import React from 'react'
import createReactClass from 'create-react-class'
import i18n from 'live/services/i18n'
import { encryptDidMount, handleEncryptSubmit } from 'live/components/forms/ui/UserTable/utils'
import EncryptForm from 'live/components/forms/ui/UserTable/EncryptForm'

var TYPE = 'samter'
var defaultObject = {
    type: 'liverig-' + TYPE,
    active: true,
    config: {
        store: {
            enabled: true,
            retry_interval: 1000,
            events_interval: 5000,
            ttl: 15,
            timestamp_mode: 'adjusted',
            curves: [],
            wells: []
        },
        fetcher: {
            enabled: true,
            uri: '',
            username: '',
            password: '',
            server_path: '',
            fetch_interval: 15000,
            retry_interval: 15000,
            event_type: 'samter',
            curves: [],
            wells: [],
            points: []
        }
    },
    fullQualifier: '',
    qualifier: '',
    status: {}
}

var ValidationMixin = require('live/components/forms/mixins/validation-mixin'),
    ObjectInitializerMixin = require('live/components/forms/mixins/object-initializer')(
        '/rest/extension',
        defaultObject
    ),
    FormBase = require('live/components/extensions/ui/form')

import ExportForm from './form-export'
import ImportForm from './form-import'

const FORMS = {
    export: ExportForm,
    import: ImportForm
}

var Form = createReactClass({
    mixins: [ObjectInitializerMixin, ValidationMixin],
    validations: {
        properties: {
            config: {
                properties: {}
            }
        }
    },

    getInitialState: function() {
        return {
            currentForm: 'import'
        }
    },

    _onSuccess: function() {
        window.location.href = '#/integrations/' + this.state.object.type + '/' + this.state.object.id
    },
    _onDelete: function() {
        window.location.href = '#/integrations/'
    },

    updateCurrentForm: function(currentForm) {
        this.setState({ currentForm })
    },
    componentDidMount() {
        encryptDidMount.bind(this)()
    },
    render: function() {
        var uiCfg = {
            hideDivider: true
        }

        var { object, currentForm } = this.state
        var FormComponent = FORMS[currentForm]
        handleEncryptSubmit.bind(this)()

        return (
            <EncryptForm self={this} uiCfg={uiCfg} test={false}>
                <div className="samter">
                    <div className="row">
                        <div className="col-md-12">
                            <ul className="form-menu">
                                <li
                                    className={currentForm === 'import' ? 'active' : ''}
                                    onClick={this.updateCurrentForm.bind(this, 'import')}
                                >
                                    {i18n('Import settings')}
                                </li>
                                <li
                                    className={currentForm === 'export' ? 'active' : ''}
                                    onClick={this.updateCurrentForm.bind(this, 'export')}
                                >
                                    {i18n('Export settings')}
                                </li>
                            </ul>
                        </div>
                    </div>

                    {FormComponent ? <FormComponent object={object} applyObj={this.applyObj} self={this} /> : ''}
                </div>
            </EncryptForm>
        )
    }
})

module.exports = Form
